<template>
  <b-icon icon="trash" />
</template>

<script>
export default { name: 'DeleteIcon', }
</script>
